import { useId } from "react";
import mockData from "mock/not-found";

import Container from "components/grid/container";
import NotFoundListItem from "components/not-found-list-item";

import styles from "./styles.module.css";

const NotFoundList = () => {
  const id = useId();
  return (
    <div className={styles.wrapper}>
      <Container>
        <h2 className={styles.title}>Aşağıdakilerden birini arıyor olabilir misiniz?</h2>
        {mockData && (
          <ul className={styles.list}>
            {mockData.categoryTree.map((item, index) => (
              <li key={`${id}${index}`}>
                <NotFoundListItem data={item} />
              </li>
            ))}
          </ul>
        )}
      </Container>
    </div>
  );
};

export default NotFoundList;
